import styled from 'styled-components';

export default styled.div`
  gap: var(--size-lg);
  display: flex;
  flex: 1;
  flex-direction: column;

  .loading-icon {
    color: #1570EF;
  }

  .leaflet-popup {
    top: -var(--size-lg) !important;
    left: var(--size-lg) !important;

    .leaflet-popup-tip-container {
      opacity: 0;
    }

    .leaflet-popup-close-button {
      display: none;
    }
  }

  .id {
    label {
      font-size: 14px;
      color: var(--color-primary-70);
      font-weight: 700;
      margin-bottom: 0px;
    }
  }

  .name {
    padding: 5px 0px;

    h4 {
      margin-bottom: 0px;
      font-weight: 500;
      font-size: 20px;
    }
  }

  .map {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
  }

  .bottom-section {
    display: flex;
    gap: 8%;

    .default-section {
      flex: 1;
    }
  }
`;
